/**
 * 多版本菜单 B6（老扫码站 U-B6-3）：预览的两句顾客能看到的话（翻译键与英文原文逐字照搬 kiosk `defaults.ts`，
 * 法 / 中两语用 kiosk 现成译文，见 `config/defaultSettings.js`；其它语言回英文）。
 * - 预览中（横幅 + 结账按钮旁的原因，owner D56 / B6-Q6）：`Preview — orders can't be placed`
 * - 预览已结束（owner D84 / D88）：`This preview has ended — showing the main menu. Ask for a new link to see it again.`
 */
import { t } from '@/utils/language'

export function previewOrdersDisabledText() {
  return t('preview_orders_disabled', 'Preview — orders can\'t be placed')
}

/** @param {'none'|'active'|'ended'} status */
export function previewBannerText(status) {
  if (status === 'ended') return t('preview_ended', 'This preview has ended — showing the main menu. Ask for a new link to see it again.')
  if (status === 'active') return previewOrdersDisabledText()
  return ''
}
